import SearchProvider from './Search.provider';

export default SearchProvider;
